import axios from "axios";
import {
    URLAPI,
    BANK_PATH,
    BANK_CREATE_PATH,
    BANK_UPDATE_PATH,
} from "../config";
import {LOGOUT} from './users'

const init = {
    _get_all_bank: {
        data: [],
        status: 0,
        message: {},
    },
    _create_bank: {
        data: {},
        status: 0,
        message: {},
    },
    _update_bank: {
        data: {},
        status: 0,
        message: {},
    },
}

const GET_ALL_BANK_SUCCESS = "GET_ALL_BANK_SUCCESS";
export const CREATE_BANK_SUCCESS = "CREATE_BANK_SUCCESS";
export const UPDATE_BANK_SUCCESS = "UPDATE_BANK_SUCCESS";


export const bank_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_BANK_SUCCESS:
            return {
                ...state,
                _get_all_bank: action.payload,
            };
        case CREATE_BANK_SUCCESS:
            return {
                ...state,
                _create_bank: action.payload,
            };
        case UPDATE_BANK_SUCCESS:
            return {
                ...state,
                _update_bank: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}


export const get_all_bank = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${BANK_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_BANK_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_BANK_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_BANK_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al obtener los bancos",
                },
            });
        }
    }
}


export const create_bank = (token, data) => async (dispatch) => {
    try {

        const response = await axios.post(`${URLAPI}${BANK_CREATE_PATH}`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: CREATE_BANK_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: CREATE_BANK_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_BANK_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al crear el banco",
                },
            });
        }
    }
}


export const update_bank = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${BANK_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_BANK_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: UPDATE_BANK_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_BANK_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const clear_status_bank = (type) => async dispatch => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}